<template>
  <v-card>
    <v-card-title>
      <label text plain @click="$emit('input', !value)" class="cursor-pointer label">
        <v-icon class="mr-2" :color="iconColor">{{ icon }}</v-icon>
        <slot name="label">
          <span>{{ label }}</span>
        </slot>
      </label>
    </v-card-title>
    <v-slide-y-transition>
      <v-card-text v-if="value">
        <slot></slot>
      </v-card-text>
    </v-slide-y-transition>
  </v-card>
</template>

<script>
export default {
  name: 'CheckboxDrawer',
  computed: {
    icon() {
      return this.value ? this.checkedIcon : this.uncheckedIcon
    },
  },
  props: {
    value: Boolean,
    label: String,
    checkedIcon: {
      type: String,
      default: 'mdi-checkbox-marked',
    },
    uncheckedIcon: {
      type: String,
      default: 'mdi-checkbox-blank-outline',
    },
    iconColor: {
      type: String,
      default: 'primary',
    },
  },
}
</script>

<style scoped>
.label {
  display: inline-flex;
  align-items: center;
}
</style>
